import aashto from './Aashto/Config';
import arizMethods from './Ariz/Config';
import asMethods from './As/Config';
import astm from './Astm/Config';
import bs11_3_11_4_MethodConfig from './Bs/11.3_11.4/Config';
import bs11_5_11_6_MethodConfig from './Bs/11.5_11.6/Config';
import bs11_7_MethodConfig from './Bs/11.7/Config';

export default {
  ...aashto,
  ...astm,
  ...asMethods,
  ...arizMethods,
  ...bs11_3_11_4_MethodConfig,
  ...bs11_5_11_6_MethodConfig,
  ...bs11_7_MethodConfig,
};
